import { render, staticRenderFns } from "./navigation-panel.vue?vue&type=template&id=22263705&scoped=true"
import script from "./navigation-panel.vue?vue&type=script&lang=js"
export * from "./navigation-panel.vue?vue&type=script&lang=js"
import style0 from "./navigation-panel.vue?vue&type=style&index=0&id=22263705&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22263705",
  null
  
)

export default component.exports